import React from 'react';
import { useTranslation } from 'react-i18next';
import OrderDetailSectionCard from '../components/OrderDetailSectionCard';
import InvoiceCoverageSummary, { InvoiceCoverageTag } from '../../invoices/components/InvoiceCoverageSummary';
import type { InvoiceCoverage } from '../../../types/invoiceCoverage';

/**
 * WP11: „Fakturowanie zamówienia” on the ZK and ZD detail pages — the active
 * invoices (number, month) and invoiced / remaining quantity per line.
 * Quantities only (visible to OPERATIONS and the sales rep); hidden while the
 * order has no active invoice or the coverage is unknown.
 */
export default function OrderInvoiceCoverageSection({ coverage, defaultOpen = false }: {
  coverage: InvoiceCoverage | null | undefined;
  defaultOpen?: boolean;
}) {
  const { t } = useTranslation('invoices');
  if (!coverage || coverage.state === 'NONE') return null;
  return <OrderDetailSectionCard title={t('invoices:workflow.coverage.title')} extra={<InvoiceCoverageTag coverage={coverage} />}
    defaultOpen={defaultOpen} data-testid="order-invoice-coverage">
    <InvoiceCoverageSummary coverage={coverage} />
  </OrderDetailSectionCard>;
}
